var _path, _circle, _circle2, _circle3, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.13096V3.5C2 2.39543 2.89543 1.5 4 1.5H20C21.1046 1.5 22 2.39543 22 3.5V6.13096M2 6.13096V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V6.13096M2 6.13096H22M5.9599 8.5V8.5C5.15708 8.5 4.50627 9.15081 4.50627 9.95363V18V18C4.50627 18.9453 5.27261 19.7117 6.21794 19.7117H17.4813C18.4266 19.7117 19.193 18.9453 19.193 18V18V9.90351C19.193 9.12837 18.5646 8.5 17.7895 8.5V8.5H5.9599Z",
    stroke: "#BF9A6D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.8,
    cy: 3.8,
    r: 0.8,
    stroke: "#BF9A6D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.29,
    cy: 3.8,
    r: 0.8,
    stroke: "#BF9A6D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7797,
    cy: 3.8,
    r: 0.8,
    stroke: "#BF9A6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11L8.14265 11.3898C7.47845 12.1144 7.41872 13.2073 8 14V14C8.58128 14.7927 8.52155 15.8856 7.85735 16.6102L7.5 17",
    stroke: "#BF9A6D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11L12.1427 11.3898C11.4784 12.1144 11.4187 13.2073 12 14V14C12.5813 14.7927 12.5216 15.8856 11.8573 16.6102L11.5 17",
    stroke: "#BF9A6D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11L16.1427 11.3898C15.4784 12.1144 15.4187 13.2073 16 14V14C16.5813 14.7927 16.5216 15.8856 15.8573 16.6102L15.5 17",
    stroke: "#BF9A6D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOven);
export default __webpack_public_path__ + "static/media/oven.48b6e1b82b44c79cb6747d3cde066580.svg";
export { ForwardRef as ReactComponent };